module.exports = __webpack_public_path__ + "static/media/385GriffinStNW_2018-06-05_45.76d06fe3.jpg";